// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-email-phone-modal .modal2__container {
    width: 478px;
}

.edit-email-phone-modal .modal2__header__title.baloa-subtitle-2 {
    font-size: 18px;
}

.edit-email-phone-modal__form {
    padding: 18px 40px;
}

.edit-email-phone-modal__form .baloa-names {
    font-weight: var(--font-regular);
    margin-bottom: 12px;
    color: var(--primary-very-dark-color);
}

.edit-email-phone-modal__form .baloa-table {
    color: var(--primary-very-dark-color);
    margin-top: 24px;
}

.edit-email-phone-modal__form__actual-data {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 24px;
    text-align: center;
}

.edit-email-phone-modal__form__actual-data .baloa-names {
    font-weight: var(--font-regular);
}

.edit-email-phone-modal__form .input-field {
    margin: 40px 0 0 0;
}

.edit-email-phone-modal__form .input-field-label {
    font-size: var(--space);
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.edit-email-phone-modal__form .input-field-input {
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: 16px 8px;
}

.edit-email-phone-modal__form-actions {
    padding: 12px 16px;
    border-top: 1px solid var(--new-gray-background-color);
    text-align: right;
}

.edit-email-phone-modal__form-actions .button {
    margin-left: auto;
}

.edit-email-phone-modal__form__phone {
    display: flex;
    margin-top: var( --space-half );
    position: relative;
}

.edit-email-phone-modal__form__phone .select-field {
    margin: 0;
}

.edit-email-phone-modal__form__phone .select-field .select-field-input {
    border-radius: calc( var( --space-half ) + 1px ) 0px 0px calc( var( --space-half ) + 1px ); 
    background-color: #ECECEC; /* TODO change to var */
    border: 0;
}

.edit-email-phone-modal__form__phone .input-field {
    margin: 0;
    width: 100%;
}

.edit-email-phone-modal__form__phone .input-field .input-field-input {
    border-radius: 0px  var( --space-half ) var( --space-half ) 0px;
    background-color: var(--white-color);
    border: solid 1.5px var(--new-gray-background-color);
    border-left: none;
}

.edit-email-phone-modal__form__phone .select-field .MuiInput-underline:before,
.edit-email-phone-modal__form__phone .select-field .MuiInput-underline:after {
    border-bottom: 0;
}

.edit-email-phone-modal__form__phone .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before{
    border: none;
}

.edit-email-phone-modal__vertical-separator__container {
    height: calc( var( --space-x3 ));
    display: flex;
    align-items: center;
    border-top: solid 1.5px var(--new-gray-background-color);
    border-bottom: solid 1.5px var(--new-gray-background-color);
}

.edit-email-phone-modal__vertical-separator {
    height: var( --space-x2 );
    align-items: center;
    border:  1px solid #999999
}


.edit-email-phone-modal__form__phone .search_country_content.country_code .base-Popper-root{
    width: 320px !important;
}

.edit-email-phone-modal__code-title {
    display: flex;
    align-items: center;
    width: 100%;
    text-align: center;
    margin-bottom: 24px;
}

.edit-email-phone-modal__code-title .baloa-subtitle-2 {
    color: var(--primary-very-dark-color);
}

.edit-email-phone-modal__code-title span {
    margin-right: 10px;
    cursor: pointer;    
}

.edit-email-phone-modal__form .baloa-names span {
    color: var(--new-green-color);
}

.edit-email-phone-modal__otp-input .input-field-input {
    font-size: 25px;
    text-align: center;
    padding: 10px;
    letter-spacing: var(--space-half)
}

.edit-email-phone-modal__resend {
    display: flex;
    justify-content: center;
    margin-top: 24px;
}

.edit-email-phone-modal__resend-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 36px;
    margin-bottom: 34px;
}

.edit-email-phone-modal__resend-buttons .button {
    padding: 12px 20px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .edit-email-phone-modal .modal2__container {
        margin: 0;
        height: 100%;
        max-height: unset;
        border-radius: 0;
        background: var(--white-color);
    }

    .edit-email-phone-modal .modal2__content {
        height: 100%;
    }

    .edit-email-phone-modal__form {
        padding: 40px 12px;
    }

    .edit-email-phone-modal__form__actual-data .baloa-names {
        margin-bottom: 4px;
    }

    .edit-email-phone-modal__form__actual-data {
        padding: 16px;
    }

    .edit-email-phone-modal__form-actions {
        position: fixed;
        bottom: 0;
        width: 100%;
    }

    .edit-email-phone-modal__form-actions .button {
        width: 100%;
    }

    .edit-email-phone-modal__form-actions .button.small {
        font-size: 16px;
        padding: 12px;
    }

    .edit-email-phone-modal__form .button.text-button {
        margin-left: auto;
        margin-right: auto;
        margin-top: 24px;
        font-size: 16px;
    }
    /* .edit-email-phone-modal__code-title {
        justify-content: flex-start;
        margin-left: var(--space);
    } */
}`, "",{"version":3,"sources":["webpack://./src/app/user-settings/components/edit-email-phone-modal/EditEmailPhoneModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;IAClD,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,sDAAsD;IACtD,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,0FAA0F;IAC1F,yBAAyB,EAAE,uBAAuB;IAClD,SAAS;AACb;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,+DAA+D;IAC/D,oCAAoC;IACpC,oDAAoD;IACpD,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,wDAAwD;IACxD,2DAA2D;AAC/D;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,SAAS;QACT,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;QAChB,8BAA8B;IAClC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,SAAS;QACT,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;IACnB;IACA;;;OAGG;AACP","sourcesContent":[".edit-email-phone-modal .modal2__container {\n    width: 478px;\n}\n\n.edit-email-phone-modal .modal2__header__title.baloa-subtitle-2 {\n    font-size: 18px;\n}\n\n.edit-email-phone-modal__form {\n    padding: 18px 40px;\n}\n\n.edit-email-phone-modal__form .baloa-names {\n    font-weight: var(--font-regular);\n    margin-bottom: 12px;\n    color: var(--primary-very-dark-color);\n}\n\n.edit-email-phone-modal__form .baloa-table {\n    color: var(--primary-very-dark-color);\n    margin-top: 24px;\n}\n\n.edit-email-phone-modal__form__actual-data {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: 20px;\n    margin-bottom: 24px;\n    text-align: center;\n}\n\n.edit-email-phone-modal__form__actual-data .baloa-names {\n    font-weight: var(--font-regular);\n}\n\n.edit-email-phone-modal__form .input-field {\n    margin: 40px 0 0 0;\n}\n\n.edit-email-phone-modal__form .input-field-label {\n    font-size: var(--space);\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.edit-email-phone-modal__form .input-field-input {\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: 16px 8px;\n}\n\n.edit-email-phone-modal__form-actions {\n    padding: 12px 16px;\n    border-top: 1px solid var(--new-gray-background-color);\n    text-align: right;\n}\n\n.edit-email-phone-modal__form-actions .button {\n    margin-left: auto;\n}\n\n.edit-email-phone-modal__form__phone {\n    display: flex;\n    margin-top: var( --space-half );\n    position: relative;\n}\n\n.edit-email-phone-modal__form__phone .select-field {\n    margin: 0;\n}\n\n.edit-email-phone-modal__form__phone .select-field .select-field-input {\n    border-radius: calc( var( --space-half ) + 1px ) 0px 0px calc( var( --space-half ) + 1px ); \n    background-color: #ECECEC; /* TODO change to var */\n    border: 0;\n}\n\n.edit-email-phone-modal__form__phone .input-field {\n    margin: 0;\n    width: 100%;\n}\n\n.edit-email-phone-modal__form__phone .input-field .input-field-input {\n    border-radius: 0px  var( --space-half ) var( --space-half ) 0px;\n    background-color: var(--white-color);\n    border: solid 1.5px var(--new-gray-background-color);\n    border-left: none;\n}\n\n.edit-email-phone-modal__form__phone .select-field .MuiInput-underline:before,\n.edit-email-phone-modal__form__phone .select-field .MuiInput-underline:after {\n    border-bottom: 0;\n}\n\n.edit-email-phone-modal__form__phone .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before{\n    border: none;\n}\n\n.edit-email-phone-modal__vertical-separator__container {\n    height: calc( var( --space-x3 ));\n    display: flex;\n    align-items: center;\n    border-top: solid 1.5px var(--new-gray-background-color);\n    border-bottom: solid 1.5px var(--new-gray-background-color);\n}\n\n.edit-email-phone-modal__vertical-separator {\n    height: var( --space-x2 );\n    align-items: center;\n    border:  1px solid #999999\n}\n\n\n.edit-email-phone-modal__form__phone .search_country_content.country_code .base-Popper-root{\n    width: 320px !important;\n}\n\n.edit-email-phone-modal__code-title {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    text-align: center;\n    margin-bottom: 24px;\n}\n\n.edit-email-phone-modal__code-title .baloa-subtitle-2 {\n    color: var(--primary-very-dark-color);\n}\n\n.edit-email-phone-modal__code-title span {\n    margin-right: 10px;\n    cursor: pointer;    \n}\n\n.edit-email-phone-modal__form .baloa-names span {\n    color: var(--new-green-color);\n}\n\n.edit-email-phone-modal__otp-input .input-field-input {\n    font-size: 25px;\n    text-align: center;\n    padding: 10px;\n    letter-spacing: var(--space-half)\n}\n\n.edit-email-phone-modal__resend {\n    display: flex;\n    justify-content: center;\n    margin-top: 24px;\n}\n\n.edit-email-phone-modal__resend-buttons {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 36px;\n    margin-bottom: 34px;\n}\n\n.edit-email-phone-modal__resend-buttons .button {\n    padding: 12px 20px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .edit-email-phone-modal .modal2__container {\n        margin: 0;\n        height: 100%;\n        max-height: unset;\n        border-radius: 0;\n        background: var(--white-color);\n    }\n\n    .edit-email-phone-modal .modal2__content {\n        height: 100%;\n    }\n\n    .edit-email-phone-modal__form {\n        padding: 40px 12px;\n    }\n\n    .edit-email-phone-modal__form__actual-data .baloa-names {\n        margin-bottom: 4px;\n    }\n\n    .edit-email-phone-modal__form__actual-data {\n        padding: 16px;\n    }\n\n    .edit-email-phone-modal__form-actions {\n        position: fixed;\n        bottom: 0;\n        width: 100%;\n    }\n\n    .edit-email-phone-modal__form-actions .button {\n        width: 100%;\n    }\n\n    .edit-email-phone-modal__form-actions .button.small {\n        font-size: 16px;\n        padding: 12px;\n    }\n\n    .edit-email-phone-modal__form .button.text-button {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 24px;\n        font-size: 16px;\n    }\n    /* .edit-email-phone-modal__code-title {\n        justify-content: flex-start;\n        margin-left: var(--space);\n    } */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
